module.exports = __webpack_public_path__ + "static/media/pousada_9.e6b5837b.jpg";